<template>
  <div class="clsCls">
  </div>
  <div style="position: relative;height:calc(100% - 150px); background:var(--color-0013)">
    <img style="width:140px; height: auto; position: absolute; top:45%; left:50%; transform:translate(-50%, -50%)"
      src="@/assets/img/404_1.png" />
    <p style="font-size:14px; position:absolute; top:60%;  left:50%; transform:translate(-50%, -50%)">啊哦~本次查验未成功！
    </p>
  </div>

  <!-- <div style="position:absolute; bottom:0px; ">
    <div style="width:100%; display:flex; justify-content: space-around;">
      <van-button @click="back" class="btn1Cls" style="width:150px;" type="primary" round>返回</van-button>
      <van-button @click="scan" class="btn2Cls" style="width:150px;" type="primary" round>再次查奖</van-button>
    </div>

    <p style="padding:10px 40px;color:var(--color-9999)">
      本产品仅为辅助工具，对验奖准确性不做保证中将情况请以官方开奖公告及兑奖结果为准</p>
  </div> -->

  <p style="text-align:center; width:100%; position:absolute; top:40px; font-size:40px; font-weight: 800;">识别失败了！
  </p>

  <div
    style="padding:20px; text-align:center; position:absolute; top:120px; height:170px; width:80%; left:50%; transform:translateX(-50%); border-radius:10px; background:#fff">
    <p>——请确保所识别为以下彩种——</p>
    <p style="color: var(--color-0015); padding:20px 50px;">大乐透、双色球、福彩3D、排列3、七星彩、排列5、快乐8</p>

    <div style="display:flex; justify-content: space-around;">
      <van-button @click="goZS" style="width:100px; margin-right:10px;" type="primary" round>开奖走势</van-button>
      <van-button @click="goFA" style="width:100px; margin-right:10px;" type="primary" round>方案大厅</van-button>
      <van-button @click="scan" class="btn2Cls" style="width:100px;" type="primary" round>再次查奖</van-button>
    </div>
    <p style="padding:10px 0px;color:var(--color-9999)">
      本产品仅为辅助工具，对验奖准确性不做保证中将情况请以官方开奖公告及兑奖结果为准</p>
  </div>
</template>
<script setup>

const props = defineProps({
  back: { type: Function, default: null },
  lotId: { type: Number, default: 0 },
})

const back = () => {
  props.back(0);
}

const scan = () => {
  props.back(1);
}

const goZS = () => {
  window.parent.postMessage({ text: "zs", lotId: props.lotId });
}

const goFA = () => {
  window.parent.postMessage({ text: "fa", lotId: props.lotId });
}

</script>
<style lang="less" scoped>
p {
  font-size: 14px;
}

.camera-container {
  width: 100%;
  /* 设置容器大小 */
  height: 100%;
  background-color: #000;
  text-align: center;

  .content {
    position: relative;
    width: calc(100% - 60px);
    height: calc(100% - 250px);
    display: inline-block;

    .kk {
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
    }
  }

  >p {
    font-size: 12px;
    color: #fff;
    margin: 0px;
    padding-left: 10px;
    padding-top: 10px;
    text-align: left;
    margin-bottom: 10px;
  }

  .btn {
    width: 60px;
    height: 60px;
    background-color: #fff;
    display: inline-block;
    margin-top: 40px;
    border-radius: 30px;
  }
}

.clsCls {
  background-image: url(@/assets/img/bg_1.png);
  width: 100%;
  height: 150px;
  background-size: cover;
  background-position: center;
}
</style>